import { InstanceOf, Record, String } from "runtypes";
export const SavedImpersonating = Record({
  netID: String,
  impersonating: String,
  created: InstanceOf(Date),
  expires: InstanceOf(Date)
});
//# sourceMappingURL=impersonating.js.map
